<template>
  <div class="wrap login-history">
    <div v-if="showSpinner" class="spinner-container">
      <spinner-el />
    </div>
    <div class="recent-login__container" :class="{ 'recent-login__container_full': !smallVersion }" v-else>
      <head-title class="head-title">
        <div class="top-title">
          <slot name="title"/>
        </div>
        <router-link v-if="smallVersion" to="/recent-logins">
          <icon-base class="icon-wrap" red>
            <icon-arrow-btn/>
          </icon-base>
        </router-link>
      </head-title>
        <table-el gray class="table">
          <tr slot="thead">
            <th class="table__th">IP</th>
            <th class="table__th table__th-location">LOCATION</th>
            <th class="table__th">LOGIN TIME</th>
          </tr>
          <tr slot="tbody" v-for="loginData in recentLogins" :key="loginData.id" class="table__tr">
            <td class="table__td">{{loginData.ip}}</td>
            <td class="table__td table__td-location">{{loginData.location}}</td>
            <td
              class="table__td"
              :title="loginData.createdAt | format(dateTimeFormat)"
            >{{loginData.createdAt | formatLoginDate(smallVersion)}}</td>
          </tr>
        </table-el>
        <div class="all-entries" v-if="smallVersion">There are <router-link to="/recent-logins" class="all-entries__link">{{recentLoginsTotalCount | formatCountEntries}}</router-link></div>
        <load-more-btn :disabled="loadingMore" class="load-more" @click="loadMore" v-else-if="showLoadingMoreBtn" :count="loadMoreCount"></load-more-btn>
    </div>
  </div>
</template>


<script>
import { format } from 'date-fns';
import { mapActions, mapState } from 'vuex';
import { IconArrowBtn } from 'Icons';
import { formatDate, getAvailableCountForLoadingMore, formatCountEntries } from 'src/utils/helpers';
import { maxCountLoadingMoreBtn, shortMonthDateFormat, dateTimeFormat } from 'src/utils/config';

export default {
  data: () => ({
    loadingMore: false,
    firstFourRecentLogins: [],
    recentLoginsIsLoaded: false,
  }),
  props: {
    smallVersion: Boolean,
  },
  components: {
    IconArrowBtn,
  },
  computed: {
    dateTimeFormat: () => dateTimeFormat,
    ...mapState('userData', [
      'recentLogins',
      'recentLoginsTotalCount',
    ]),
    showLoadingMoreBtn() {
      return this.recentLoginsTotalCount > this.recentLogins.length;
    },
    loadMoreCount() {
      return getAvailableCountForLoadingMore(this.recentLoginsTotalCount, this.recentLogins.length); // eslint-disable-line
    },
    showSpinner() {
      return !this.recentLoginsIsLoaded && !this.smallVersion;
    },
  },
  methods: {
    ...mapActions('userData', [
      'updateRecentLogins',
      'loadMoreRecentLogins',
    ]),
    loadMore() {
      this.loadingMore = true;
      this.loadMoreRecentLogins().then(() => {
        this.loadingMore = false;
      });
    },
  },
  filters: {
    format,
    formatCountEntries,
    formatLoginDate(val, smallVersion) {
      return smallVersion ? formatDate(val, shortMonthDateFormat) : formatDate(val);
    },
  },
  created() {
    const limit = this.smallVersion ? 5 : maxCountLoadingMoreBtn;
    this.updateRecentLogins(limit).then(() => {
      this.recentLoginsIsLoaded = true;
    });
  },
};
</script>

<style lang="scss" scoped>
  .table {
    text-align: left;
    width: 100%;
  }
  .table__th {
    padding: 12px 30px;
  }
  .table__td {
    font-size: 13px !important;
    padding: 18px 30px;
  }
  .table__td-location {
    line-height: 21px;
  }
  .table__tr {
    border-bottom: 1px solid $grey-color3;
  }
  .head-title {
    margin-bottom: 26px;
    margin-left: 30px;
  }
  .recent-login__container {
    border-radius: 5px;
    background: $white-color2;
    padding: 27px 0 0;
    &_full {
      padding: 31px 0 0;
      margin-left: 90px;
      max-width: 646px;
      .head-title {
        margin-bottom: 32px;
      }
    }
  }
  .load-more {
    padding: 30px !important;
    display: block;
  }
  .top-title {
    display: inline-block;
  }
  .icon-wrap {
    float: right;
    margin-right: 29px;
    margin-top: 6px;
    cursor: pointer;
    @include clearfix();
  }
  .all-entries {
    padding: 19px 31px 22px;
    @include font(13px, $grey-color9, 500);
    &__link {
      text-decoration: none;
      color: $red-color3 !important;
    }
  }
  .spinner-container {
    justify-content: center;
    align-items: center;
    margin-top: -120px;
  }
  @media only screen and (max-width : 1184px) {
    .table__td {
      padding-right: 0;
    }
  }
  @media only screen and (max-width : 900px) {
    .recent-login__container_full {
      margin: 0 10px;
      max-width: 100%;
    }
  }
  @media only screen and (max-width : 570px) {
    .login-history {
      .table__th-location,
      .table__td-location {
        display: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/LoginHistory.vue